<template>
  <div id="Nav">

    <div class="bar">
      <div class="left">
        <img class="logo" src="@/assets/images/nav/logo-tab.png" alt="Rangers logo"
          v-scroll-to="{ el: '#swiper-header', offset: -53 }" />
        <img class="globelife" src="@/assets/images/nav/lonstar-member.png" alt="LoneStar Member" />
        <div class="divider" />
      </div>
      <div class="right" :class="{ active: menuActive }">
        <scrollactive :offset="63" class="nav" active-class="active">
          <a href="#" data-section-selector="#Home" class="scrollactive-item"
            v-scroll-to="{ el: '#Home' }">Home</a>
          <a href="#" data-section-selector="#Benefits" class="scrollactive-item"
            v-scroll-to="{ el: '#Benefits' }">Plan Benefits</a>
          <!-- <a
              href="#Plans"
              data-section-selector="#Preset"
              class="scrollactive-item"
              v-scroll-to="{ el: '#Preset' }"
              >Preset<br />Plans</a
            > -->
          <a href="#" data-section-selector="#Create" class="scrollactive-item"
            v-scroll-to="{ el: '#Create' }">Fan's Choice</a>
          <!-- <a href="#" data-section-selector="#Preset" class="scrollactive-item"
            v-scroll-to="{ el: '#Preset' }">Preset Plans</a> -->
          <!-- <a
              href="#Ready"
              data-section-selector="#Ready"
              class="scrollactive-item"
              v-scroll-to="{ el: '#Ready' }"
              >Lock in<br />Your Seats</a
            > -->
        </scrollactive>
        <div class="phone">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
              fill="#6CA9E4" />
          </svg>
          <a href="tel:972-726-4377">972-RANGERS (X3)</a>
        </div>
        <a href="#BookSuite" class="more-info" v-scroll-to="{ el: '#BookSuite', offset: -53 }">Contact Us</a>
        <div class="burger" :class="{ active: menuActive }" @click="menuActive = !menuActive">
          <div class="line" />
          <div class="line" />
          <div class="line" />
          <div class="line" />
        </div>
      </div>

    </div>
    <nav class="menu" :class="{ active: menuActive }">
      <div class="menu-container">
        <scrollactive :offset="63" class="nav" active-class="active">
          <a @click="menuActive = !menuActive" href="#Slider-selector" data-section-selector="#Slider-selector" class="scrollactive-item"
            v-scroll-to="{ el: '#Home' }">Home</a>
          <a @click="menuActive = !menuActive" href="#Benefits-selector" data-section-selector="#Benefits-selector" class="scrollactive-item"
            v-scroll-to="{ el: '#Benefits' }">Plan Benefits</a>
          <a @click="menuActive = !menuActive" href="#Plans" data-section-selector="#Create" class="scrollactive-item"
            v-scroll-to="{ el: '#Create' }">Fan's Choice</a>
          <!-- <a @click="menuActive = !menuActive" href="#Seats" data-section-selector="#Preset" class="scrollactive-item"
            v-scroll-to="{ el: '#Preset' }">Preset Plans</a> -->
        </scrollactive>
        <div class="contact">
          <div class="phone">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
                fill="#6CA9E4" />
            </svg>
            <a href="tel:972-726-4377">972-RANGERS (X3)</a>
          </div>
          <a @click="menuActive = !menuActive" href="#BookSuite" class="more-info" v-scroll-to="{ el: '#BookSuite', offset: -53 }">Contact Us</a>
        </div>
      </div>

    </nav>

  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      menuActive: false,
    };
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
};
</script>

<style lang="scss" scoped>
#Nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  backdrop-filter: blur(5px);
  background: linear-gradient(90deg, hsla(0, 0%, 100%, .9) 25%, hsla(0, 0%, 91%, .9));
  filter: drop-shadow(0 0 25px rgba(0, 0, 0, .25));

  .bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 77px;
    width: 100%;

    @media screen and (max-width: $lg) {
      height: 65px;
    }

    .left,
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
    }

    .left {
      padding-right: 40px;
      align-items: center;
      gap: 40px;

      @media screen and (max-width: 1200px) {
        gap: 25px;
        padding-right: 25px;
      }

      @media screen and (max-width: $lg) {
        align-items: flex-start;
      }

      .logo {
        width: 148px;
        margin-top: auto;

        @media screen and (max-width: $lg) {
          width: auto;
          height: 73px;
          margin-top: 0;
        }
      }

      .globelife {
        width: 55px;

        @media screen and (max-width: $lg) {
          display: none;
        }
      }

      .divider {
        height: 40px;
        width: 1px;
        background: var(--STH-Warm-Gray, #BFB8AF);

        @media screen and (max-width: $lg) {
          display: none;
        }
      }

      .globelife {
        @media (max-width: 576px) {
          display: none;
        }
      }
    }

    .right {
      position: relative;
      flex: 1;
      justify-content: space-between;
      padding-right: 45px;
      gap: 40px;

      @media screen and (max-width: 1200px) {
        gap: 25px;
      }

      @media (max-width: 992px) {
        justify-content: flex-end;
        padding-right: 25px;
      }


      .nav {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 30px;

        @media (max-width: 1200px) {
          gap: 15px;
        }

        @media (max-width: 992px) {
          display: none;
        }

        .scrollactive-item {
          color: var(--STH-Dark-Blue, #1E376D);
          text-align: center;
          font-family: Druk;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          letter-spacing: 0.36px;
          text-transform: uppercase;
          text-decoration: none;
          padding: 0 10px;
          position: relative;
          transition: all 0.3s ease-in-out;

          @media screen and (max-width: 1200px) {
            font-size: 15px;
          }

          &::after {
            position: absolute;
            content: "";
            top: 0;
            left: 0;
            width: 0;
            height: calc(100% + 2px);
            background-color: #c50d33;
            z-index: -1;
            transition: all 0.3s ease-in-out;
          }

          &:hover,
          &.active {
            color: #fff;

            &::after {
              width: 100%;
            }
          }

        }
      }

      .more-info {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 18px 45px;
        border-radius: 4px;
        background: var(--STH-Dark-Blue, #1E376D);
        color: #FFF;
        text-align: center;
        font-family: Druk;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.36px;
        text-transform: uppercase;
        text-decoration: none;

        @media (max-width: 992px) {
          display: none;
        }

        @media (max-width: 350px) {
          width: 150px;
          font-size: 10px;
        }
      }

      .burger {
        position: relative;
        width: 28px;
        height: 28px;
        cursor: pointer;
        padding: 5px 2px;
        z-index: 1;

        @media (min-width: 992px) {
          display: none;
        }

        &.active {
          .line {

            &:nth-child(1),
            &:nth-child(4) {
              top: 1.25rem;
              width: 0%;
              left: 50%;
            }

            &:nth-child(2) {
              transform: rotate(45deg);
            }

            &:nth-child(3) {
              transform: rotate(-45deg);
            }
          }
        }

        .line {
          display: block;
          position: absolute;
          width: 100%;
          height: 2px;
          left: 2px;
          border: none;
          outline: none;
          opacity: 1;
          border-radius: 100px;
          background: #1E376D;
          transform: rotate(0deg);
          transition: transform 0.5s ease-in-out, background 0.5s ease-in-out;

          &:nth-child(1) {
            top: 5px;
            width: 100%;
          }

          &:nth-child(2),
          &:nth-child(3) {
            top: 12px;
            width: 100%;
          }

          &:nth-child(4) {
            top: 19px;
            width: 100%;
          }
        }
      }
    }

    .phone {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 10px;

      @media (max-width: 992px) {
        display: none;
      }

      img {
        margin-right: 10px;
      }

      a {
        color: var(--STH-Dark-Blue, #1E376D);
        text-align: center;
        font-family: Druk;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.36px;
        text-transform: uppercase;
        text-decoration: none;

        @media screen and (max-width: 1200px) {
          font-size: 15px;
        }
      }

    }
  }

  .menu {
    position: absolute;
    right: -325px;
    top: 0px;
    height: 100vh;
    height: 100dvh;
    width: 100vw;
    max-width: 325px;
    // background-color: #fff;
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 25%, rgba(231, 231, 231, 1) 100%);
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(5px);
    transition: all 0.5s ease-in-out;

    @media (min-width: 993px) {
      display: none;
    }

    &.active {
      right: 0;
    }

    .menu-container {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      width: 100%;
      padding: 25px;

      .nav {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding-bottom: 10%;
        gap: 65px;

        @media screen and (max-height: 750px) {
          gap: 45px;
        }

        .scrollactive-item {
          color: var(--STH-Dark-Blue, #1E376D);
          text-align: center;
          font-family: Druk;
          font-size: 36px;
          font-style: normal;
          font-weight: 700;
          line-height: 36px;
          letter-spacing: 0.72px;
          text-transform: uppercase;
          text-decoration: none;
          text-align: left;
          width: 100%;
        }
      }

      .contact {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;

        .phone {
          display: flex;
          align-items: center;
          gap: 10px;

          a {
            color: var(--STH-Dark-Blue, #1E376D);
            text-align: center;
            font-family: Druk;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            letter-spacing: 0.36px;
            text-transform: uppercase;
          }
        }

        .more-info {
          width: 100%;
          border-radius: 4px;
          background: var(--STH-Dark-Blue, #1E376D);
          color: #FFF;
          text-align: center;
          font-family: Druk;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 13px;
          letter-spacing: 0.36px;
          text-transform: uppercase;
          padding: 18px 45px;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
